// types/media.ts

// ========== MEDIA TYPES ==========

export type MediaType = 'image' | 'video' | 'audio';

// Resposta da API ao listar/obter mídia
export interface MediaResponse {
    original_filename: any;
    file_size_kb: any;
    id: number;
    user_id: number;
    page_id: string;
    filename: string;
    file_url: string;
    thumbnail_url?: string;
    media_type: MediaType;
    file_size: number;
    attachment_id: string | null;
    created_at: string;
    updated_at?: string;
    // WebP de exibição (960px). O front deve carregar esta, nunca a original:
    // a original é o arquivo que vai para a Meta e pesa ~1,5 MB.
    preview_url?: string | null;
    folder_id?: number;
}

// Resposta paginada da API
export interface PaginatedMediaResponse {
    items: MediaResponse[];
    total: number;
    page: number;
    per_page: number;
    pages: number;
}

// Request para upload de mídia
export interface UploadMediaRequest {
    file: File;
    page_id: string;
    send_to_meta?: boolean;
    // Pasta de destino. 0 (ou omitido) envia para a raiz.
    folder_id?: number;
}

// Request para atualizar attachment_id
export interface UpdateAttachmentRequest {
    attachment_id: string;
}

// Resposta de upload (igual a MediaResponse)
export type UploadMediaResponse = MediaResponse;

// Resposta de delete
export interface DeleteMediaResponse {
    message: string;
    success: boolean;
}

// Filtros para listagem
export interface MediaFilters {
    media_type?: MediaType;
    page_id?: string;
    page?: number;
    per_page?: number;
    // 0 = raiz. undefined lista a biblioteca inteira (usado pela busca).
    folder_id?: number;
    busca?: string;
}
// ========== RECORTE 1,91:1 ==========

// Enquadramento em pixels da imagem ORIGINAL (não da tela)
export interface MediaCrop {
    x: number;
    y: number;
    width: number;
    height: number;
    // Cor da faixa quando a arte não preenche a moldura inteira
    background?: string;
}

export interface CropMediaRequest extends MediaCrop {
    source_url: string;
}

// Imagem derivada, já na proporção que a Meta renderiza sem cortar
export interface CropMediaResponse {
    file_url: string;
    filename: string;
    width: number;
    height: number;
    source_url: string;
    crop: MediaCrop;
}


// ========== PASTAS DA BIBLIOTECA ==========

// 0 = raiz. Sentinela em vez de null porque no MySQL um NULL na chave
// desligaria a UNIQUE que impede duas pastas de mesmo nome no mesmo nível.
export const PASTA_RAIZ = 0;

export interface MediaFolder {
    id: number;
    user_id: number;
    parent_id: number;
    nome: string;
    total_midias: number;
}

export interface CreateFolderRequest {
    nome: string;
    parent_id?: number;
}

export interface MoveMediaRequest {
    media_ids: number[];
    folder_id: number;
}
